import { To } from "@remix-run/router/history"
import React from "react"
import { NavigateButton } from "../../../components/buttons/navigate-button/NavigateButton"
import { customPalette } from "../../../../theme"

interface IProps {
  label: string
  path: To
}

export function HomePageButton({ label, path }: Readonly<IProps>): React.JSX.Element {
  return (
    <NavigateButton
      label={label}
      path={path}
      sx={{ borderRadius: 3, color: "white", backgroundColor: customPalette.mediumGreen3, maxHeight: 50 }}
    />
  )
}
